import React, { CSSProperties, FC, memo, ReactElement, useEffect, useRef } from 'react';

import styles from './styles.module.scss'

type MenuListItemPropTypes = {
    item: ReactElement;
    setSize: (index: number, size: number) => void;
    style: CSSProperties,
    index: number;
    windowWidth: number;
};

const MenuListItem: FC<MenuListItemPropTypes> = memo(({ item, setSize, style, index, windowWidth }) => {
    const divRef = useRef<HTMLDivElement>();

    useEffect(() => {
        if (divRef.current) {
            setSize(index, divRef.current.getBoundingClientRect().height);
        }
    }, [setSize, index, divRef.current, windowWidth]);

    return (
        <div style={style} ref={divRef}>
            {item}
        </div>
    );
});

export default MenuListItem;